import { cn } from "../lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			aria-busy="true"
			aria-hidden="true"
			className={cn(
				"animate-pulse rounded-md bg-accent motion-reduce:animate-none motion-reduce:opacity-70",
				className,
			)}
			data-slot="skeleton"
			{...props}
		/>
	);
}

export { Skeleton };
